import Button, { ButtonGroup } from "@atlaskit/button";
import React from "react";
import { Link } from "react-router-dom";
import NotificationDirectIcon from "@atlaskit/icon/glyph/notification-direct";
import RecentIcon from "@atlaskit/icon/glyph/recent";
export var NotificationHeader = function (props) { return (React.createElement(ButtonGroup, null,
    React.createElement(Link, { to: "/services/" + encodeURIComponent(props.serviceId) + "/resilience/notifications" },
        React.createElement(Button, { key: "notification", iconBefore: React.createElement(NotificationDirectIcon, { label: "notification", size: "small" }) }, "Notification")),
    React.createElement("a", { href: "http://go/brahmos", target: "_blank", rel: "noopener noreferrer" },
        React.createElement(Button, { key: "Get Support", iconBefore: React.createElement(RecentIcon, { label: "history", size: "small" }) }, "Get Support")))); };
